import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { questions } from '../data/faq';
export function FAQ() {
  const [open, setOpen] = useState(0);
  return <section className="bg-slate-950 py-20" aria-labelledby="faq-title" data-id="element-48" data-mp="1ceqcvl9bmtg8">
      <div className="mx-auto max-w-3xl px-4" data-id="element-49" data-mp="1ccdpgsksnqvs">
        <SectionHeading id="faq-title" data-id="element-50" data-mp="2a2idyqbi2et3">Frequently Asked <span className="text-amber-400" data-id="element-51" data-mp="2a05vmc1ty2fi">Questions</span></SectionHeading>
        <div className="mt-10 space-y-3" data-id="element-52" data-mp="253oxqq4tw9p8">
          {questions.map(([question, answer], index) => {
          const isOpen = index === open;
          return <article key={question} className={`overflow-hidden rounded-xl border bg-blue-950 transition-colors duration-150 ease-out ${isOpen ? 'border-amber-400/70' : 'border-slate-600/50'}`} data-id="element-53" data-mp="1v5841lei9gzh" data-mpi={index}>
                <h3 className="font-sans" data-id="element-54" data-mp="jpsz9vg21ktt">
                  <button type="button" className="flex w-full items-center justify-between gap-5 px-5 py-5 text-left font-bold text-stone-50 transition-colors duration-150 ease-out hover:bg-blue-900 focus:outline-none focus-visible:ring-4 focus-visible:ring-inset focus-visible:ring-amber-400/50 sm:px-6" onClick={() => setOpen(isOpen ? -1 : index)} aria-expanded={isOpen} data-id="element-55" data-mp="jp1d1b8ckzg7">
                    <span data-id="element-56" data-mp="1fnuepis9tqmv">{question}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-amber-400 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-57" data-mp="1fmsryh1w7fpb" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-58" data-mp="16ps3kaetphlv">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-59" data-mp="s0m8myn0qdjs">
                      <p className="border-t border-slate-600/30 px-5 py-4 leading-relaxed text-slate-300 sm:px-6" data-id="element-60" data-mp="2pnoogpfnnqth">{answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </article>;
        })}
        </div>
      </div>
    </section>;
}